import React, { useState } from 'react';
import './Animations.css';

const Animations = ({ project }) => {
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'list'

  return (
    <div className="animations-container">
      <div className="animations-header">
        <button className="create-video-btn">
          <i className="fas fa-plus"></i>
          <span>Create video</span>
        </button>
        
        <div className="view-mode-controls">
          <button 
            className={`mode-btn ${viewMode === 'grid' ? 'active' : ''}`}
            onClick={() => setViewMode('grid')}
          >
            <i className="fas fa-th"></i>
          </button>
          <button 
            className={`mode-btn ${viewMode === 'list' ? 'active' : ''}`}
            onClick={() => setViewMode('list')}
          >
            <i className="fas fa-list"></i>
          </button>
        </div>
      </div>

      <div className="animations-content">
        <div className="empty-state">
          <p>There are no animations defined in this project</p>
        </div>
      </div>
    </div>
  );
};

export default Animations;